import { InputErrorMessageVariantType } from '../../../../../components/internal/inputErrorMessage/types/inputErrorMessageVariantType';
import { FONT_WEIGHT } from '../../foundations/typography';
import { CheckboxBaseVariantType } from '../checkboxBase/variants';
import { TextVariantType } from '../text/variants';
export const commonStateStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    ...STATE_TOKENS,
    container: {
        width: 'fit-content',
        ...STATE_TOKENS.container,
    },
    checkboxWithLabelContainer: {
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
        flex_direction: 'row',
        align_items: 'center',
        border_radius: FOUNDATIONS.radius_comp_forms_checkbox_radiussize,
        focusWithin: {
            outline: 'none',
            box_shadow: `0 0 ${FOUNDATIONS.blur_00} ${FOUNDATIONS.spread_50} ${FOUNDATIONS.color_effect_focus_50}, 0 0 ${FOUNDATIONS.blur_00} ${FOUNDATIONS.spread_100} ${FOUNDATIONS.color_effect_focus_100}`,
        },
        ...STATE_TOKENS.checkboxWithLabelContainer,
    },
    errorMessageContainer: {
        display: 'flex',
        // spacing between checkbox and error message + checkbox size
        margin_left: `calc(${FOUNDATIONS.spacing_150} + ${FOUNDATIONS.size_300})`,
        ...STATE_TOKENS.errorMessageContainer,
    },
    errorMessage: {
        variant: InputErrorMessageVariantType.REGULAR,
        ...STATE_TOKENS.errorMessage,
    },
    checkboxBase: {
        variant: CheckboxBaseVariantType.REGULAR,
        ...STATE_TOKENS.checkboxBase,
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
        cursor: 'pointer',
        ...STATE_TOKENS.label,
    },
});
export const errorCommonStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    ...commonStateStyles(FOUNDATIONS, FONT, {
        ...STATE_TOKENS,
        container: {
            border_color: FOUNDATIONS.color_feedback_error_border_50,
            ...STATE_TOKENS.container,
        },
    }),
});
export const disabledCommonStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    ...commonStateStyles(FOUNDATIONS, FONT, {
        ...STATE_TOKENS,
        container: {
            border_color: FOUNDATIONS.color_accent_disabled_border_100,
            ...STATE_TOKENS.container,
        },
        label: {
            color: FOUNDATIONS.color_accent_disabled_font_50,
            cursor: 'default',
            ...STATE_TOKENS.label,
        },
    }),
});
//# sourceMappingURL=commonStyles.js.map